import React from 'react';
import { MARCAS, useMarca, setMarcaActiva, hashConMarca, vistaFromHash } from '../engine/marcas';

export const Header = ({ title, onHome, children, className = '' }) => {
  const [marca] = useMarca();
  const esMbm = marca.id === 'mbm';

  const cambiar = (id) => {
    setMarcaActiva(id);
    const h = window.location.hash;
    if (h.startsWith('#sitio') || h.startsWith('#corredor')) {
      window.location.hash = hashConMarca(vistaFromHash(h), id);
    }
  };

  return (
    <header className={`hdr${className ? ' ' + className : ''}`} data-testid="header">
      <button type="button" className="hdr-brand" onClick={onHome} data-testid="btn-home">
        {esMbm ? (
          <img src="/mbm-logo.svg" alt="MBM" width={34} height={34} />
        ) : (
          <span className="hdr-mono" style={{ background: marca.color }} data-testid="hdr-mono">{marca.mono}</span>
        )}
        <span className="hdr-word" data-testid="hdr-marca-nombre">{marca.nombre}</span>
      </button>
      {title ? <span className="hdr-title">{title}</span> : null}
      <div className="hdr-right">
        <label className="hdr-entidad-wrap">
          <span>Entidad</span>
          <select className="hdr-entidad" value={marca.id} onChange={(e) => cambiar(e.target.value)} data-testid="hdr-entidad">
            {Object.values(MARCAS).map((m) => (
              <option key={m.id} value={m.id}>{m.nombre}</option>
            ))}
          </select>
        </label>
        {children}
      </div>
    </header>
  );
};
